var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    { staticClass: "flex gap-1 flex-wrap text-sm font-normal" },
    [
      _vm._l(_vm.chipWithLinkDatas, function (chipWithLinkData, index) {
        return _vm.limit <= 0 || index < _vm.limit
          ? _c("ChipWithLink", {
              attrs: {
                variant: chipWithLinkData.variant,
                chipLink: chipWithLinkData.chipLink,
                chipData: chipWithLinkData.chipData,
                avatar: chipWithLinkData.avatar,
                chipText: chipWithLinkData.chipText,
                wrapChip: _vm.wrapChips,
              },
            })
          : _vm._e()
      }),
      _vm.limit <= 0 && _vm.extra > 0
        ? _c(
            "span",
            {
              staticClass: "font-bold py-0.5 px-1.5 rounded-full",
              class:
                _vm.variant === "green"
                  ? "bg-greenChip text-lightGreen"
                  : _vm.variant === "blue"
                  ? "bg-lightBlue text-darkBlue"
                  : "bg-gray-300 text-gray-800",
            },
            [_vm._v("+" + _vm._s(_vm.extra))]
          )
        : _vm._e(),
      !_vm.chipWithLinkDatas.length ? _c("span", [_vm._v("N/A")]) : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }